module.exports = __webpack_public_path__ + "img/flag.7fb49320.svg";